import React from 'react'
import './inicio-section.scss'
import Button from '../../atoms/button/button'
import useMediaQuery from '../../../utils/useMediaQuery'
import { navigate } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import getUserInfo from '../../../utils/getUserInfo'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import { jsonToHash } from '../../../utils/crypto'
import AnimationRewards from '../../atoms/animation-rewards/animation-rewards'
import { LOCALE, topNumber } from '../../../constants/activity-constants'
import { compartirFacebook } from '../../../utils/shareFnc'
import { WORDS } from '../../../constants/keywords'

const PremiosByLocale = () => {
  if (LOCALE === 'es-DO') {
    return (
      <StaticImage
        src="../../../assets/images/home-section/rewards-image-do.png"
        alt="premios republica dominicana"
        placeholder="blurred"
        className="f-contentHomeSection__animation__image"
      />
    )
  }
  if (LOCALE === 'es-PR') {
    return (
      <StaticImage
        src="../../../assets/images/home-section/rewards-image-pr.png"
        alt="premios puerto rico"
        placeholder="blurred"
        className="f-contentHomeSection__animation__image"
      />
    )
  }
  if (LOCALE === 'es-BO') {
    return (
      <StaticImage
        src="../../../assets/images/home-section/rewards-image-bo.png"
        alt="premios bolivia"
        placeholder="blurred"
        className="f-contentHomeSection__animation__image"
      />
    )
  }
  if (LOCALE === 'es-PY') {
    return (
      <StaticImage
        src="../../../assets/images/home-section/rewards-image-py.png"
        alt="premios Paraguay"
        placeholder="blurred"
        className="f-contentHomeSection__animation__image"
      />
    )
  }
  if (LOCALE === 'es-UY') {
    return (
      <StaticImage
        src="../../../assets/images/home-section/no-reward-image.png"
        alt="premios Urugay"
        style={{ bottom: '-12px' }}
        placeholder="blurred"
        className="f-contentHomeSection__animation__image"
      />
    )
  }
  return <AnimationRewards type={1} />
}
const Premios = () => (
  <div className="f-contentHomeSection__animation">{PremiosByLocale()}</div>
)
const getLogoRompeTabus = () => {
  if (['es-AR', 'es-PY', 'es-UY'].includes(LOCALE)) {
    return (
      <StaticImage
        className="f-contentHomeSection__center__logo"
        src="../../../assets/images/home-section/logoRompeTaboos-arg.png"
        alt="Rompé Tabús"
      />
    )
  }
  return (
    <StaticImage
      className="f-contentHomeSection__center__logo"
      src="../../../assets/images/home-section/logoRompeTaboos.webp"
      alt="Rompe Tabus"
    />
  )
}
const getRightTextByLocale = () => {
  if (['es-AR', 'es-PY', 'es-UY'].includes(LOCALE)) {
    return (
      <>
        <b>Recorré el laberinto</b> y recogé tooodos <br />
        los elementos que podás, pero no permitás que los tabúes te capturen
      </>
    )
  }
  return (
    <>
      <b>Recorre el laberinto</b> y recoge tooodos <br />
      los elementos que puedas, pero no permitas que los tabúes te capturen
    </>
  )
}
const userInfo = getUserInfo()
const toggleButton = async evt => {
  if (evt) {
    let text = evt.target?.innerText
    if (text) {
      if (text) {
        pushEventData({
          event: 'Interacciones_Home_RompeTabus',
          label: text,
          user_data: userInfo && [
            await jsonToHash({
              nombre: userInfo.name,
              apellido: userInfo.lastName,
              celular: userInfo.cellPhone,
              correo: userInfo.email,
              ciudad: userInfo.location.cityName,
              departamento: userInfo.location.countryStateName,
              pais: userInfo.countryName,
            }),
          ],
          log_status: userInfo ? 'Yes' : 'Not',
        })
      }
    }
  }
  navigate('/game')
}
const getButtonGoText = () => {
  if (['es-AR', 'es-PY', 'es-UY'].includes(LOCALE)) {
    return <>¡Quiero jugar!</>
  }
  return <>¡Quiero jugar ya!</>
}
const InicioSection = ({ id, className }) => {
  const redirectBoton = (
    <Button onClick={toggleButton}>{getButtonGoText()}</Button>
  )
  const isMobile = useMediaQuery()

  return (
    <section id={id} className={'f-contentHomeSection ' + className}>
      <div className="f-contentHomeSection__wrapper">
        <div className="f-contentHomeSection__left">
          <div className="f-contentHomeSection__text">
            <p>
              <b>
                ¡Hablemos sin pena sobre <br /> nuestros cuerpos y la
                sexualidad!
              </b>{' '}
            </p>
          </div>
          <StaticImage
            src="../../../assets/images/home-section/logoHomeJuego.webp"
            alt="pacman juego"
            placeholder="blurred"
            className="f-contentHomeSection__left__img --imgMws98"
          />
          <p
            className={
              isMobile
                ? 'f-contentHomeSection__text --size14'
                : 'f-contentHomeSection__text'
            }
          >
            {getRightTextByLocale()}
          </p>
          {isMobile && redirectBoton}
        </div>
        <div className="f-contentHomeSection__center">
          {getLogoRompeTabus()}
          {!isMobile && redirectBoton}
        </div>
        <div className="f-contentHomeSection__right">
          {!isMobile && <Premios />}

          {LOCALE !== 'es-UY' && (
            <p className="f-contentHomeSection__text">
              <b>¡Llega al top {topNumber} </b> para que <br />
              {WORDS.ganes} premios como estos!
            </p>
          )}
          {isMobile && <Premios />}
        </div>
      </div>
    </section>
  )
}

export default InicioSection
